<template>
    <div id="verification">

        <div class="panel" :class="$route.query.hideBorder && '-no-border'">
            <transition name="fade" mode="out-in">
                <in-progress v-if="verificationState === 'inprogress'" key="in-progress" />
                <browse v-if="verificationState === 'waiting'" key="browse" />
                <success v-if="verificationState === 'success'" key="success" />
                <Unknown v-if="verificationState === 'failed' && verification.status === 'UNKNOWN'" key="unknown" />
                <untrusted v-if="verificationState === 'failed' && verification.status === 'UNTRUSTED'" key="untrusted" />
                <unsupported v-if="verificationState === 'failed' && verification.status === 'UNSUPPORTED'" key="unsupported" />
            </transition>

            <div class="signer" v-if="signer">
                <small>Signer: <strong>{{ signer.id }}</strong></small>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import '../css/config';
@import '../css/transition';

#verification {
    text-align: center;

    .panel {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 252px;
        padding: $spacer * 2 $spacer;

        ::v-deep .success,
        ::v-deep .error,
        ::v-deep .browse {
            text-align: center;

            .icon {
                width: 60px;
                height: 60px;
                margin-bottom: $spacer;
                margin-left: auto;
                margin-right: auto;
            }

            .inkline-icon {
                font-size: 60px;
            }

            a {
                display: block;
                margin-top: $spacer;
            }
        }
    }

    .signer {
        margin-top: $spacer;
    }

    ::v-deep .list {
        a {
            color: $link-color;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .button {
        margin-bottom: $spacer * 2;
    }
}

.area:not(.-box) .panel {
    border: 2px dashed $border-color;
    padding: 0 $spacer;
    margin: $spacer * 2 0;

    &.-no-border {
        border: 0;
    }
}
</style>

<script>
import InProgress from "../components/verification/InProgress";
import Browse from "../components/verification/Browse";
import Success from "../components/verification/Success";
import Untrusted from "../components/verification/Untrusted";
import Unknown from "../components/verification/Unknown";
import Unsupported from "../components/verification/Unsupported";

export default {
    data: () => ({
        alertActive: false
    }),
    components: {
        InProgress,
        Browse,
        Unknown,
        Untrusted,
        Success,
        Unsupported
    },
    mounted() {
        setTimeout(() => {
            this.alertActive = true;
        }, 1000);
    },
    computed: {
        verification: function() {
            return this.$store.getters.verification;
        },
        verificationState: function() {
            return this.$store.getters.verificationState;
        },
        organization() {
            return this.$store.getters.organization;
        },
        signer() {
            return this.$store.getters.signer;
        }
    }
};
</script>
